/**
 * @generated SignedSource<<26746346fd93d005fb9c7cb122e6644f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type IdentityProviderType = "AWS" | "Azure" | "GCP" | "SAML" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  qualifier?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type GroupSectionsGridGroupsQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  filterElement?: FilterElementInput | null | undefined;
  first?: number | null | undefined;
  last?: number | null | undefined;
};
export type GroupSectionsGridGroupsQuery$data = {
  readonly userGroups: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly displayName: string | null | undefined;
        readonly id: string;
        readonly members: {
          readonly pageInfo: {
            readonly total: number | null | undefined;
          };
        };
        readonly name: string;
        readonly roleAssignments: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly role: {
                readonly name: string;
              };
              readonly target: {
                readonly __typename: "AccountGroup";
                readonly name: string;
              } | {
                // This will never be '%other', but we need some
                // value in case none of the concrete values match.
                readonly __typename: "%other";
              };
            };
          }> | null | undefined;
          readonly pageInfo: {
            readonly total: number | null | undefined;
          };
        };
        readonly source: {
          readonly __typename: string;
          readonly displayName?: string | null | undefined;
          readonly idpAlias: string | null | undefined;
          readonly idpNamespace: string;
          readonly idpType: IdentityProviderType;
          readonly name?: string;
        } | null | undefined;
        readonly uuid: any;
        readonly " $fragmentSpreads": FragmentRefs<"RoleAssignmentTable_principal">;
      };
    }> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly startCursor: string | null | undefined;
      readonly total: number | null | undefined;
    };
  };
};
export type GroupSectionsGridGroupsQuery = {
  response: GroupSectionsGridGroupsQuery$data;
  variables: GroupSectionsGridGroupsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterElement"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "filterElement",
    "variableName": "filterElement"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": "name"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v8/*:: as any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "UserGroupMemberConnection",
  "kind": "LinkedField",
  "name": "members",
  "plural": false,
  "selections": [
    (v9/*:: as any*/)
  ],
  "storageKey": "members(first:1)"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v13 = [
  (v11/*:: as any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": (v13/*:: as any*/),
  "type": "AccountGroup",
  "abstractKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "idpAlias",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "idpNamespace",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "idpType",
  "storageKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": (v13/*:: as any*/),
  "type": "CloudOrganization",
  "abstractKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*:: as any*/),
    (v11/*:: as any*/)
  ],
  "type": "SAMLProvider",
  "abstractKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    },
    (v8/*:: as any*/)
  ],
  "storageKey": null
},
v23 = [
  (v11/*:: as any*/),
  (v21/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GroupSectionsGridGroupsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "UserGroupConnection",
        "kind": "LinkedField",
        "name": "userGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  {
                    "alias": null,
                    "args": (v12/*:: as any*/),
                    "concreteType": "RoleAssignmentConnection",
                    "kind": "LinkedField",
                    "name": "roleAssignments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleAssignmentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoleAssignment",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v7/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Role",
                                "kind": "LinkedField",
                                "name": "role",
                                "plural": false,
                                "selections": (v13/*:: as any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "target",
                                "plural": false,
                                "selections": [
                                  (v14/*:: as any*/),
                                  (v15/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v9/*:: as any*/)
                    ],
                    "storageKey": "roleAssignments(first:100)"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RoleAssignmentTable_principal"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "source",
                    "plural": false,
                    "selections": [
                      (v14/*:: as any*/),
                      (v16/*:: as any*/),
                      (v17/*:: as any*/),
                      (v18/*:: as any*/),
                      (v19/*:: as any*/),
                      (v20/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v22/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "GroupSectionsGridGroupsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "UserGroupConnection",
        "kind": "LinkedField",
        "name": "userGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  {
                    "alias": null,
                    "args": (v12/*:: as any*/),
                    "concreteType": "RoleAssignmentConnection",
                    "kind": "LinkedField",
                    "name": "roleAssignments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleAssignmentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoleAssignment",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v7/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Role",
                                "kind": "LinkedField",
                                "name": "role",
                                "plural": false,
                                "selections": [
                                  (v11/*:: as any*/),
                                  (v7/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "target",
                                "plural": false,
                                "selections": [
                                  (v14/*:: as any*/),
                                  (v15/*:: as any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v7/*:: as any*/)
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v9/*:: as any*/)
                    ],
                    "storageKey": "roleAssignments(first:100)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "source",
                    "plural": false,
                    "selections": [
                      (v14/*:: as any*/),
                      (v16/*:: as any*/),
                      (v17/*:: as any*/),
                      (v18/*:: as any*/),
                      (v19/*:: as any*/),
                      (v20/*:: as any*/),
                      (v7/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": (v12/*:: as any*/),
                        "concreteType": "RoleAssignmentConnection",
                        "kind": "LinkedField",
                        "name": "roleAssignments",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoleAssignmentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RoleAssignment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "source",
                                    "plural": false,
                                    "selections": [
                                      (v14/*:: as any*/),
                                      (v7/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "target",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v6/*:: as any*/)
                                        ],
                                        "type": "RoleScope",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v21/*:: as any*/)
                                        ],
                                        "type": "AccountGroup",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v23/*:: as any*/),
                                        "type": "PolicyCollection",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v23/*:: as any*/),
                                        "type": "RepositoryConfig",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v23/*:: as any*/),
                                        "type": "UserGroup",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v13/*:: as any*/),
                                        "type": "Repository",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "roleAssignments(first:100)"
                      }
                    ],
                    "type": "RolePrincipal",
                    "abstractKey": "__isRolePrincipal"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v22/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3a1fed0a3e75a41abcf70fa609dbb250",
    "id": null,
    "metadata": {},
    "name": "GroupSectionsGridGroupsQuery",
    "operationKind": "query",
    "text": "query GroupSectionsGridGroupsQuery(\n  $filterElement: FilterElementInput\n  $first: Int\n  $last: Int\n  $after: String\n  $before: String\n) {\n  userGroups(filterElement: $filterElement, first: $first, last: $last, after: $after, before: $before, order: \"name\") {\n    edges {\n      node {\n        displayName\n        id\n        members(first: 1) {\n          pageInfo {\n            total\n          }\n        }\n        name\n        roleAssignments(first: 100) {\n          edges {\n            node {\n              id\n              role {\n                name\n                id\n              }\n              target {\n                __typename\n                ... on AccountGroup {\n                  name\n                }\n                ... on Node {\n                  __isNode: __typename\n                  id\n                }\n              }\n            }\n          }\n          pageInfo {\n            total\n          }\n        }\n        ...RoleAssignmentTable_principal\n        source {\n          __typename\n          idpAlias\n          idpNamespace\n          idpType\n          ... on CloudOrganization {\n            name\n          }\n          ... on SAMLProvider {\n            displayName\n            name\n          }\n          id\n        }\n        uuid\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      startCursor\n      total\n    }\n  }\n}\n\nfragment RoleAssignmentTable_principal on RolePrincipal {\n  __isRolePrincipal: __typename\n  roleAssignments(first: 100) {\n    edges {\n      node {\n        source {\n          __typename\n          id\n        }\n        role {\n          name\n          id\n        }\n        target {\n          __typename\n          ... on RoleScope {\n            displayName\n          }\n          ... on AccountGroup {\n            name\n            uuid\n          }\n          ... on PolicyCollection {\n            name\n            uuid\n          }\n          ... on RepositoryConfig {\n            name\n            uuid\n          }\n          ... on UserGroup {\n            name\n            uuid\n          }\n          ... on Repository {\n            name\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d631a105b32e2792cfe1b77398510f5";

export default node;
